import { Controller } from '@hotwired/stimulus'

// PDT-RNK-4681: en el formulario de una cuenta, cada tarjeta declara su coste con un
// estado cerrado. Importe y periodicidad solo tienen sentido con coste; la condición,
// solo cuando la gratuidad es condicionada. Este controller oculta lo que no aplica.
//
// Es progressive enhancement: sin JS se ven los tres grupos y el formulario sigue
// enviando. El modelo valida el estado y la periodicidad de todos modos.
//
// Targets:
//   - estado: el <select> de estado de la tarjeta
//   - importe: el grupo con importe + periodicidad
//   - condicion: el grupo con el texto de la condición
// Values (para no hardcodear en JS los valores de Cuenta::ESTADOS_TARJETA):
//   - conCoste, condicionada
export default class extends Controller {
  static targets = ['estado', 'importe', 'condicion']
  static values = { conCoste: String, condicionada: String }

  connect () {
    this.toggle()
  }

  toggle () {
    if (!this.hasEstadoTarget) return

    const estado = this.estadoTarget.value
    if (this.hasImporteTarget) this.importeTarget.hidden = estado !== this.conCosteValue
    if (this.hasCondicionTarget) this.condicionTarget.hidden = estado !== this.condicionadaValue
  }
}
